import { render, staticRenderFns } from "./FeedbackIcon.vue?vue&type=template&id=41940785&"
import script from "./FeedbackIcon.vue?vue&type=script&lang=ts&"
export * from "./FeedbackIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41940785')) {
      api.createRecord('41940785', component.options)
    } else {
      api.reload('41940785', component.options)
    }
    module.hot.accept("./FeedbackIcon.vue?vue&type=template&id=41940785&", function () {
      api.rerender('41940785', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/feedbacks/components/FeedbackIcon.vue"
export default component.exports